import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import TopNavigation from '../../dashboard/TopNavigation';
import { makeStyles } from '@material-ui/core/styles';
import { Configuration } from "../../../configs/Configuration";
import { Link } from 'react-router-dom';

import { HOME } from '../../../constants/common';
import { DASHBOARD_HOME_PATH } from '../../../constants/paths';

const useStyles = makeStyles({
  root: {
    backgroundColor: configColors => `rgb(${configColors['--color_54']})`
  }
});

export default function BCLDashboardTopNav(props){
  const configColors = Configuration.getColors().colors;
  const classes = useStyles(configColors);
  const configuration = Configuration.getConfiguration();
  const logoClass = configuration.logoCssClass;
  const img = <img className={logoClass + " utility-header-logo"} src={props.logoUrl} alt=""/>
  const headerContainerClass = props.configs.data["dashboard.header_css_container_class"];
  
  return(
      <AppBar className="app-bar" position="sticky" classes={{root: classes.root}}>
        <div className={`${headerContainerClass} app-bar-container `}>
            <div className="utility-logo-wrapper">
              {props.topMenuItems.indexOf(HOME) !== -1 ? (
                <Link to={DASHBOARD_HOME_PATH}>
                  {img}
                </Link>
              ) : (
                <> {img} </>
              )}
            </div>
            <TopNavigation/>
        </div>
      </AppBar>
    );
}